import { areCybusServiceDeviationsEquals } from '../../../../../../domain'

import type { PageSubscriptionsTypes } from '../../../../../../application'

import { BaseDeviatedServicesStrategy, type DeviatedServiceResponse, type DeviatedServicesPageSortableColumnsMap } from './BaseDeviatedService'

export class DeviationsStrategy extends BaseDeviatedServicesStrategy<'serviceDeviations'> {
    protected override deviationsSupportedType = 'serviceDeviations' as const

    protected override errorMessage = 'Could not fetch service deviations'

    protected override sortingColumns: DeviatedServicesPageSortableColumnsMap<'serviceDeviations'> = { id: 'serviceId' }

    protected override readonly areEquals = areCybusServiceDeviationsEquals

    protected override mapToDomain ({ serviceId }: DeviatedServiceResponse): Promise<PageSubscriptionsTypes['serviceDeviations']> {
        return Promise.resolve({ id: serviceId })
    }
}
